/**
 * Generated template: Classic (S+ to F)
 * Auto-generated by scripts/generate-templates.js - DO NOT EDIT
 */

import { TierListTemplate, Tier } from "@/types/tier-list";
import { TemplateMetadata } from "@/types/template-metadata";

/**
 * Template metadata (available immediately, no images loaded)
 */
export const metadata: TemplateMetadata = {
  id: "classic",
  displayName: "Classic (S+ to F)",

  description: "The classic tier list format with S+, S, A, B, C, D, F tiers",
  tiers: [
  {
    "id": "tier-s-plus",
    "label": "S+",
    "priority": 0,
    "color": {
      "label": "#000000",
      "background": "#FCD34D"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-s",
    "label": "S",
    "priority": 1,
    "color": {
      "label": "#FFFFFF",
      "background": "#7C3AED"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-a",
    "label": "A",
    "priority": 2,
    "color": {
      "label": "#FFFFFF",
      "background": "#2563EB"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-b",
    "label": "B",
    "priority": 3,
    "color": {
      "label": "#FFFFFF",
      "background": "#16A34A"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-c",
    "label": "C",
    "priority": 4,
    "color": {
      "label": "#FFFFFF",
      "background": "#EA580C"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-d",
    "label": "D",
    "priority": 5,
    "color": {
      "label": "#FFFFFF",
      "background": "#DC2626"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-f",
    "label": "F",
    "priority": 6,
    "color": {
      "label": "#FFFFFF",
      "background": "#64748B"
    },
    "fontSizeMultiplier": 2
  }
] as Tier[],
  hasItems: false,
};

/**
 * Load full template with all data including images
 * This is lazy-loaded only when the template is selected
 */
export async function loadFull(): Promise<TierListTemplate> {
  // Dynamic import loads the full JSON only when called
  const fullTemplate = await import("@/templates/classic.json");
  return fullTemplate.default as TierListTemplate;
}
